import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { memo } from 'react';
import { Button } from 'Shared/components';
import { RESET_FILTERS_BUTTON_LABEL } from './consts';
import styles from './ResetFiltersButton.css';
const ResetFiltersButton = ({ onClick, className, disabled, }) => (_jsx(Button, Object.assign({ outlined: true, onClick: onClick, className: classnames(className, styles.resetFiltersButton), testId: "resetFiltersButton", disabled: disabled, withHover: true }, { children: RESET_FILTERS_BUTTON_LABEL }), void 0));
export default memo(ResetFiltersButton);
